<template>
  <div class="single-column-content pa-5 ma-3">
    <page-title title="Set password"></page-title>
    <h1 class="title mb-5">Oauth </h1>
    <form
      action="/set-password"
      @submit.prevent="submit"
      class="login-form"
    >
      <v-layout column>
        This will Grant access to Website 
      </v-layout>
      <v-layout row justify-center class="mb-3">
        <v-btn
          color="primary"
          type="submit"
          depressed
          round
          large
          :loading="submitLoading"
          >Agree</v-btn
        >
      </v-layout>
    </form>
    
  </div>
</template>

<script>
import formMixins from '@/mixins/forms'
import userApi from '@/api/user'
export default {
  name: 'OauthGrant',
  mixins: [formMixins],
  created: function() {},
  data: function() {
    return {
      formData: {
        confirm: 'yes',
        ...this.$router.currentRoute.query
      },
      
    }
  },
  computed: {},
  methods: {
    submit: function() {
      const vm = this
      if (!this.isFormValid) return
      userApi.oauthGrantRequest(vm.formData).then(function(res) {
        window.location = res.data.results.next
      }).catch(function(res){
        console.log("Error in request")
      })
    }
  }
}
</script>

<style lang="stylus">
@require "common.styl"
    .single-column-content {
        width 500px
    }
</style>
